import React from 'react';
import { Container } from 'vendors/semantic-ui';

import { getDefault, readCMSValue } from 'modules/shared-cms/utils';
import {
    MentionContainer,
    ImagesListBloc,
    PreFooterBloc,
    TitleBlocContainer,
} from 'modules/shared-cms-advanced/components';

import { Actualite, getNestedReferenceId } from 'modules/shared-cms-advanced';
import { NouveautesCatalogue, TendanceCatalogue } from 'modules/shared-cms-catalogue';
import { LightSeparator } from 'modules/shared-ui/components';
import { UniverseProps } from './universe-type';
import enhancer from './universe-enhancer';

import styles from './universe-page.module.css';

const InnerUniverse: React.FC<UniverseProps> = React.memo((props: UniverseProps) => {
    const {
        titleBlocPicture = readCMSValue(props.titleBlocPicture),
        categories = getDefault(readCMSValue(props.categories), []),
        nouveautesID = getDefault(getNestedReferenceId(props.nouveautesCatalogue), ''),
        newsSuperTitle = getDefault(readCMSValue(props.newsSuperTitle), ''),
        actualiteID = getDefault(getNestedReferenceId(props.actualite), ''),
        tendanceSuperTitle = getDefault(readCMSValue(props.tendanceSuperTitle), ''),
        tendanceID = getDefault(getNestedReferenceId(props.tendance), ''),
        preFooterPictureList = getDefault(readCMSValue(props.preFooterPictureList), []),
        preFooterColor = readCMSValue(props.preFooterColor),
        mention = getDefault(readCMSValue(props.mention), ''),
    } = {};

    return (
        <React.Fragment>
            <div className={styles.root}>
                {titleBlocPicture && <TitleBlocContainer {...props} titleBlocPicture={titleBlocPicture} fullWidth />}
                {categories.length > 0 && (
                    <div className={styles.categoriesBloc}>
                        <ImagesListBloc list={categories} style4Items fullWidth />
                    </div>
                )}
                {nouveautesID !== '' && (
                    <React.Fragment>
                        <div className={styles.separator}>
                            <LightSeparator />
                        </div>
                        <NouveautesCatalogue id={nouveautesID} />
                    </React.Fragment>
                )}
                {actualiteID !== '' && (
                    <React.Fragment>
                        <div className={styles.separator}>
                            <LightSeparator />
                        </div>
                        <div className={styles.blockWithSuperTitle}>
                            <div className={styles.superTitle}>{newsSuperTitle}</div>
                            <div className={styles.newsContainer}>
                                <Actualite id={actualiteID} />
                            </div>
                        </div>
                    </React.Fragment>
                )}
                {tendanceID !== '' && (
                    <React.Fragment>
                        <div className={styles.separator}>
                            <LightSeparator />
                        </div>
                        <div className={styles.blockWithSuperTitle}>
                            <div className={styles.superTitle}>{tendanceSuperTitle}</div>
                            <TendanceCatalogue id={tendanceID} />
                        </div>
                    </React.Fragment>
                )}
                {preFooterPictureList.length > 0 && (
                    <div
                        className={`${preFooterPictureList.length < 4 ? styles.preFooterMin : styles.preFooterMax}`}
                        style={{ backgroundColor: preFooterColor }}
                    >
                        <PreFooterBloc preFooterPicturelist={preFooterPictureList} />
                    </div>
                )}
                {mention !== '' && (
                    <div className={styles.mentionSection}>
                        <Container>
                            <div className={styles.mentiontext}>
                                <MentionContainer {...props} mention={mention} />
                            </div>
                        </Container>
                    </div>
                )}
            </div>
        </React.Fragment>
    );
});

export const UniversePage = enhancer(InnerUniverse);
